import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Offer, RoomType } from '../../features/offerSearch/types';
import { RootState } from '../../redux/rootReducer';
import DopInformation from '../common/DopInformation/DopInformation';
import ParseHtml from '../common/ParseHtml';
import TravelDateInfo from '../common/TravelDateInfo/TravelDateInfo';
import withLocalization from '../hoc/withLocalization';
import RoomPriceInfo from '../OfferDetails/RoomPriceInfo';

interface SelectedOffeProps {
  localize?: any;
  selectedRoom: RoomType;
}

const SelectedOffer: FC<any> = (props: SelectedOffeProps): ReactElement => {
  const { localize } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const selectedRoom = offerDetails.selectedRoomType;
  const offer: Offer | undefined = offerDetails.currentOffer;
  const calculatedNumberOfDays =
    selectedRoom && selectedRoom.numberOfDays ? parseInt(selectedRoom.numberOfDays, 10) : 0;
  const calculatedNumberOfNights =
    selectedRoom && selectedRoom.numberOfNights ? parseInt(selectedRoom.numberOfNights, 10) : 0;
  let extraNights = useSelector((state: RootState) => state.availabilityDates.extraNights);
  extraNights = extraNights ? extraNights : 0;

  const premiums =
    offer && offer.premiums
      ? offer?.premiums
          .filter((x) => x !== null)
          .join(', ')
          .trim()
      : '';
  return (
    <div>
      <h5 className="h3Mont palmColor paddingTopBot upperCase">
        {localize('preview-sales-engine.static-content.copy.selected-offer-component.header')}
      </h5>
      <div className="row flipOfferContainer offerDisplay">
        <div className="col-sm-6">
          <p>
            <strong>{selectedRoom?.property?.name}</strong>
          </p>
          {localize('preview-sales-engine.static-content.copy.select-offer-page.days-nights', [
            calculatedNumberOfDays,
            calculatedNumberOfNights,
          ])}
          {extraNights > 0 ? (
            <>
              <div className="vr"></div>
              {localize('preview-sales-engine.static-content.copy.Labels.labels#extra-nights')} {extraNights}
            </>
          ) : (
            <></>
          )}
          <div className="vr"></div>
          {selectedRoom?.roomTypeDescription}
          <div className="vr"></div>
          {localize('preview-sales-engine.static-content.copy.select-offer-page.max-guests')}{' '}
          {selectedRoom?.sleepCapacity}
          {premiums ? (
            <p>
              <ParseHtml
                htmlInput={`${localize('preview-sales-engine.static-content.copy.prospects.plustext')} ${premiums}`}
              ></ParseHtml>
            </p>
          ) : (
            <></>
          )}
          <div className="row">
            <div className="col-sm-12">
              <TravelDateInfo
                lowSeasonDateRanges={offer?.lowSeasonDateRanges}
                highSeasonDateRanges={offer?.highSeasonDateRanges}
                placement="top"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <DopInformation dopCodeDetails={offer?.dopCodeDetails} />
            </div>
          </div>
        </div>
        <div className="col-sm-6 rightAlign">
          <RoomPriceInfo lowSeasonCost={selectedRoom?.startingCost} highSeasonCost={selectedRoom?.highSeasonCost} />
        </div>
      </div>
    </div>
  );
};

export default withLocalization(SelectedOffer);
